// Relative Italian date, e.g. "oggi", "ieri", "3 giorni fa", "2 settimane fa", "5 mesi fa", else full date.
export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const now = new Date();
  const secs = Math.floor((now - d) / 1000);
  if (secs < 60) return "adesso";
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins} min fa`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} ${hours === 1 ? "ora" : "ore"} fa`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "ieri";
  if (days < 7) return `${days} giorni fa`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks} ${weeks === 1 ? "settimana" : "settimane"} fa`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} ${months === 1 ? "mese" : "mesi"} fa`;
  try {
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}
